export default {
	partnerId: "2814"
}
